<div class="table-row">
  <selfai-platform-pipeline-variables-tree
    [workflowId]="globalWorkflowId"
    [includeGlobal]="true"
    [userPermissions]="userPermissions$ | async"
    [excludeColumns]="excludeColumns"
  ></selfai-platform-pipeline-variables-tree>
</div>
